<template>
    <div class="lawsuit-helper-main" @click.capture="checkAuthentice">
        <div class="box">
            <div class="header">
                <div class="header-title">AI诉保助手</div>
                <div class="subTitles">
                    <span class="subTitle">
                        百度律临 × 法师兄联合打造
                    </span>
                    <span class="subTitle">
                        多快好省快速出保函
                    </span>
                </div>
                <veui-button
                    class="button" @click="clickSubmit"
                >立即提交资料</veui-button>
            </div>
            <div class="title">使用流程</div>
            <div class="use-process">
                <div
                    v-for="item, index in processArr"
                    :key="index"
                    class="process-item"
                >
                    <div class="process-icon" :style="{backgroundImage: 'url(' + item.icon + ')'}"></div>
                    <div class="process-title">{{ item.title }}</div>
                    <div class="process-sub-title">{{ item.subTitle }}</div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="title">功能优势</div>
            <div class="advantage-box">
                <div
                    v-for="item, index in advantageArr"
                    :key="index"
                    class="advantage-item"
                >
                    <div class="top-info">
                        <div class="advantage-icon" :style="{backgroundImage: 'url(' + item.icon + ')'}"></div>
                        <div>
                            <div class="advantage-title">{{ item.title }}</div>
                            <!--bca-disable-->
                            <div class="advantage-sub-title" v-html="item.subTitle"></div>
                            <!--bca-enable-->
                        </div>
                    </div>
                    <div
                        v-for="introItem, introIndex in item.intro"
                        :key="introIndex"
                        class="intro"
                    >
                        {{ introItem }}
                    </div>
                </div>
            </div>
            <div class="submit-btn" @click="clickSubmit">立即提交资料</div>
        </div>
        <veui-dialog
            title="提示"
            :open.sync="showDialog"
            overlay-class="tip-dialog"
        >
            您即将使用律临账号注册/登录第三方系统。登录后该平台将获得以下权限：获得您的公开信息（姓名等）
            <template #foot>
                <veui-button
                    ui="m normal"
                    @click="handleDialogClick('cancel')"
                >
                    取消
                </veui-button>
                <veui-button
                    ui="m primary"
                    class="ok"
                    @click="handleDialogClick('ok')"
                >
                    确定
                </veui-button>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @author dingzhenyue
 * @desc  AI诉助助手
 */
import {Button, Dialog} from 'veui';
import {mapState} from 'vuex';
import mixinauthentice from '@/mixins/authentice';
export default {
    name: 'insuranceTool',
    components: {
        'veui-button': Button,
        'veui-dialog': Dialog
    },
    mixins: [mixinauthentice],
    data() {
        return {
            processArr: [
                {
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/process1.png',
                    title: '1.点击立即提交资料',
                    subTitle: '基于行业人工智能技术的应用，让律师诉保更简便更省心'
                },
                {
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/process2.png',
                    title: '2.诉保材料打包上传',
                    subTitle: '一键上传，数据双向加密，安全有保障'
                },
                {
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/process3.png',
                    title: '3.提交材料，等待法审',
                    subTitle: '20秒钟AI智能分类，10分钟内专属客服1对1服务'
                },
                {
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/process4.png',
                    title: '4.收取保函',
                    subTitle: '80%业务2小时内出函，100%业务当天确定是否承保'
                }
            ],
            advantageArr: [
                {
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/advantage1.png',
                    title: '人多  网点多',
                    subTitle: '<div><span>16</span>位法审、<span>100+</span>客服、'
                        + '<span>270</span>家网点覆盖、<span>33</span>个省市</div>',
                    intro: [
                        '律师+前法官构成的法审人员16人，专业客服超过100人',
                        '全国33个省市270家机构网点，已打通当地绝大部分的法院准入资格，保函认可度高'
                    ]
                },
                {
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/advantage2.png',
                    title: '响应快  出单快',
                    subTitle: '<div>专属客服<span>7*24</span>小时服务、<span>2</span>小时出函、<span>当天</span>确认</div>',
                    intro: [
                        '1对1专属客服服务，7*24小时，全年无休，节假日均可承保出单',
                        '80%业务2小时内出函，100%业务当天确定是否承保'
                    ]
                },
                {
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/advantage3.png',
                    title: '承保能力好  承保范围好',
                    subTitle: '<div>单笔超<span>30</span>亿、<span>6</span>大承保类型</div>',
                    intro: [
                        '已合作的客户，最大承保金额单笔最大超过30亿',
                        '覆盖六种承保类型，目前是行业承保类型最多的企业之一'
                    ]
                },
                {
                    icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/advantage4.png',
                    title: '客户省  律师省',
                    subTitle: '<div>性价比高、多重积分</div>',
                    intro: [
                        '全国诉保价格统一，价格公开透明，性价比高',
                        '上传诉保材料，获得诉保积分奖励，可兑换法师兄产品、加油卡、购物卡等礼品'
                    ]
                }
            ],
            showDialog: false
        };
    },
    computed: {
        ...mapState({
            authenticationStatus: state =>
                state.lawStore.authenticationStatus,
            userInfoNew: state => state.lawStore.userInfoNew || {}
        })
    },
    methods: {
        clickSubmit() {
            // 点击打点
            this.$wywLog.send({
                serverId: 17213,
                area: 'ljtjzl-btn',
                action: 'click'
            });
            // 首次会展示弹窗
            const uk = this.userInfoNew.uk;
            const fsxAuthorize = localStorage.getItem('fsxAuthorize');
            if (!fsxAuthorize || fsxAuthorize !== uk) {
                this.showDialog = true;
            }
            else {
                this.toFsx();
            }
        },
        handleDialogClick(type) {
            if (type === 'ok') {
                const uk = this.userInfoNew.uk;
                localStorage.setItem('fsxAuthorize', uk);
                this.toFsx();
            }
            this.showDialog = false;
        },
        // 跳转法师兄页面
        toFsx() {
            this.$http.get(
                '/bp/api/lawyer/ailawsuit'
            ).then(res => {
                if (res && res.data && +res.code === 0) {
                    let url = res.data.jumpUrl;
                    url && window.open(url);
                    return;
                }
                this.$toast.error(res && res.msg || '提交失败，请稍候再试~');
            }).catch(() => {
                this.$toast.error('提交失败，请稍候再试~');
            });
        }
    }
};
</script>
<style lang="less" scoped>
.lawsuit-helper-main {
    .box {
        background: #fff;
        box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
        border-radius: 8px;
        padding: 30px;

        &:not(:first-child) {
            margin-top: 24px;
        }
    }

    .header {
        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/header-bg.png") no-repeat center center / cover;
        width: 100%;
        height: 250px;
        border-radius: 8px;
        padding: 48px 60px;
        background-position: right;
        margin-bottom: 30px;

        .header-title {
            font-family: PingFangSC-Medium;
            font-size: 28px;
            color: #fff;
            line-height: 28px;
            font-weight: 500;
        }

        .subTitles {
            margin-top: 18px;
            font-family: PingFangSC-Regular;
            font-size: 18px;
            color: #fff;
            line-height: 18px;
            font-weight: 400;

            .strong {
                font-family: PingFangSC-Medium;
                font-weight: 500;
            }

            .subTitle {
                margin-right: 24px;
            }
        }

        .button {
            margin-top: 44px;
            height: 46px;
            padding: 0 28px;
            background: #fff;
            box-shadow: 2px 4px 11px 0 rgba(22, 119, 255, .23);
            border-radius: 5px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #0051ff;
            line-height: 40px;
            font-weight: 500;
            width: 228px;
        }
    }

    .title {
        font-family: PingFangSC-Medium;
        font-size: 24px;
        color: #1e1f24;
        line-height: 24px;
        font-weight: 500;
    }

    .use-process {
        display: flex;
        margin-top: 24px;
        justify-content: space-between;

        .process-item {
            width: 210px;
            text-align: center;
            position: relative;

            .process-icon {
                width: 60px;
                height: 60px;
                background-repeat: no-repeat;
                background-origin: center;
                background-size: 100% 100%;
                margin: 0 auto 24px;
            }

            &:not(:last-child)::after {
                position: absolute;
                content: "";
                top: 19px;
                right: -45px;
                width: 12px;
                height: 21px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/arraw.png") no-repeat center center / cover;
            }
        }

        .process-title {
            font-family: PingFangSC-Semibold;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
            font-weight: 600;
        }

        .process-sub-title {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #50525c;
            line-height: 28px;
            font-weight: 400;
            margin-top: 6px;
        }
    }

    .advantage-box {
        display: grid;
        margin-top: 24px;
        grid-template-rows: 208px 208px;
        grid-template-columns: 522px 522px;
        grid-row-gap: 24px;
        grid-column-gap: 24px;

        .advantage-item {
            width: 522px;
            height: 208px;
            background: rgba(244, 246, 249, .3);
            border: 1px solid rgba(202, 219, 255, .4);
            border-radius: 8px;
            padding: 24px;

            .top-info {
                display: flex;
                margin-bottom: 20px;
            }

            .advantage-icon {
                width: 66px;
                height: 66px;
                background-repeat: no-repeat;
                background-origin: center;
                background-size: 100% 100%;
                margin-right: 12px;
            }

            .advantage-title {
                font-family: PingFangSC-Semibold;
                font-size: 20px;
                color: #1e1f24;
                line-height: 18px;
                font-weight: 600;
                padding: 10px 0 12px;
            }

            .advantage-sub-title {
                color: #848691;
                line-height: 16px;
                font-size: 16px;

                /deep/ span {
                    color: #1e1f24;
                }
            }

            .intro {
                position: relative;
                padding-left: 20px;
                line-height: 24px;
                font-size: 16px;

                &::before {
                    content: "";
                    background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawsuit-helper/icon.png");
                    position: absolute;
                    height: 14px;
                    width: 14px;
                    left: 0;
                    top: 5px;
                }

                &:not(:first-child) {
                    margin-top: 5px;
                }
            }
        }
    }

    .submit-btn {
        width: 228px;
        height: 46px;
        background: #05f;
        box-shadow: 2px 4px 11px 0 rgba(22, 119, 255, .23);
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #fff;
        text-align: center;
        line-height: 46px;
        font-weight: 500;
        margin: 24px auto 0;
        cursor: pointer;
    }
}
</style>
<style lang="less">
.tip-dialog {
    .veui-dialog-content {
        width: 454px;
        background-image: linear-gradient(180deg, #e1f8ff 0%, #e4f0ff 15%, #fff 45%);
        border-radius: 4px;
    }

    .veui-dialog-content-head {
        align-items: center;
        justify-content: center;
        padding-top: 30px;
        padding-bottom: 24px;
        position: relative;

        .veui-dialog-content-head-title {
            flex-grow: 0;
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #1e1f24;
            letter-spacing: 0;
            line-height: 24px;
            font-weight: 500;
        }

        .veui-dialog-content-head-close {
            position: absolute;
            right: 30px;
        }
    }

    .veui-dialog-content-body {
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #1e1f24;
        line-height: 28px;
        font-weight: 400;
    }

    .veui-dialog-content-foot {
        text-align: center;
        padding-top: 24px !important;

        .veui-button {
            width: 92px;
            height: 40px;
            border: 1px solid #05f;
            border-radius: 4px;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #05f;
            line-height: 16px;
            font-weight: 400;
            background: #fff;

            &.ok {
                background: #05f;
                color: #fff;
            }
        }
    }
}
</style>
